import React from 'react';

import TodoCreateNewOrder from './TodoCreateOrderDialogs/TodoCreateNewOrder';

const TodoDialogs: React.FC = () => (
  <>
    <TodoCreateNewOrder />
  </>
);

export default TodoDialogs;
